export default __webpack_public_path__ + "static/media/transition_video.91700014.mp4";